module.exports = __webpack_public_path__ + "img/slider2.9c297bb.jpg";